module.exports = __webpack_public_path__ + "media/bootstrap-icons/handbag-83d7a1ea.svg";